import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  inject,
  isDevMode
} from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { loadConfig } from './core/config/config.loader';
import { baseUrlInterceptor } from './core/interceptors/base-url.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { OnlineStatusService } from 'ngx-online-status';
import {provideTranslateService, provideTranslateLoader} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import { AppConfigService } from './core/config/app-config.service';
import { subscriptionInterceptor } from './core/interceptors/subscription.interceptor';
import { provideLottieOptions } from 'ngx-lottie';

// ✅ NEW Angular 21 way (no deps array, no factory fn)
function initConfig() {
  const configService = inject(AppConfigService);

  return loadConfig().then(cfg => {
    configService.set(cfg);
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideRouter(routes),

    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor,
        errorInterceptor,
        subscriptionInterceptor
      ])
    ),
    OnlineStatusService,

    AppConfigService,

    // ✅ modern initializer
    provideAppInitializer(initConfig),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),

  //Service Worker
  provideServiceWorker('ngsw-worker.js', {
  enabled: !isDevMode(),
  registrationStrategy: 'registerWhenStable:30000'
}),
 provideLottieOptions({
      player: () => import('lottie-web'),
    }),
  ]
};